module.exports = require('./helpers/bundle-url').getBundleURL('cfrUe') + "logo.c51670a8.svg";